


























































































































































































































import Vue from 'vue'
import { COLOR_PAGE_BG } from '@/theme'
import { setDocumentTitle, formatAmount } from '@/util'
import { env } from '@ivy/fts/envInfo/envInfo'
import config from '../../config'

interface Product {
  id: number
  product_id: number
  product_name: string
  product_image: string
  product_price: number
  quantity: number
}

interface Tier {
  id: number
  threshold_amount: number
  stock_remaining: number
  is_achieved: boolean
  tier_status: string
  is_claimable: boolean
  status_rich_text: string
  is_need_receiver: boolean
  products: Product[]
}

interface UserProgress {
  total_paid_amount: string
  settled_amount: string
  progress_percent: number
  next_tier_amount: number
  remaining_amount: number
  reward_claim_text: string
}

interface Activity {
  id: number
  name: string
  activity_time_text: string
  claim_deadline: string
  status: number
  reward_mode: number
  rules: string[]
}

const UNCLAIMABLE_STATUSES = ['not_achieved', 'achieved_not_highest']

export default Vue.extend({
  name: 'ActivityDetail',
  data() {
    return {
      COLOR_PAGE_BG,
      loading: false,
      receiver: null as any,
      claimDialog: '' as '' | 'fill' | 'confirm' | 'success',
      claimingTierId: 0,
      // 首次挂载时快照路由参数，避免 iOS bfcache 恢复时 $route 短暂为空导致丢参
      activityId: '',
      onPageShow: null as null | (() => void),
      activity: {
        id: 0,
        name: '',
        activity_time_text: '',
        claim_deadline: '',
        status: 1,
        reward_mode: 1,
        rules: [],
      } as Activity,
      userProgress: {
        total_paid_amount: '0.00',
        settled_amount: '0.00',
        progress_percent: 0,
        next_tier_amount: 0,
        remaining_amount: 0,
        reward_claim_text: '',
      } as UserProgress,
      progressTipRichText: '',
      tiers: [] as Tier[],
    }
  },

  computed: {
    progressPct(): number {
      return Math.min(Math.max(this.userProgress.progress_percent, 0), 100)
    },
    pctLabelStyle(): object {
      const pct = this.progressPct
      if (pct <= 8) return { left: '0' }
      if (pct >= 92) return { right: '0' }
      return {
        left: pct + '%',
        transform: 'translateX(-50%), translateY(-50%)',
      }
    },
    addressText(): string {
      const r: any = this.receiver
      if (r && r.province_name && r.city_name && r.address) {
        return `${r.province_name}${r.city_name}${r.district_name || ''}${
          r.address
        }`
      }
      return ''
    },
  },

  async mounted() {
    setDocumentTitle('消费赢壕礼')
    this.activityId = (this.$route.query.id as string) || ''
    await this.verifyLoginAndFetchDetail()
    this.onPageShow = () => this.fetchDetail()
    window.addEventListener('pageshow', this.onPageShow)
    this.checkReturnFromAddress()
  },

  beforeDestroy() {
    if (this.onPageShow) {
      window.removeEventListener('pageshow', this.onPageShow)
      this.onPageShow = null
    }
  },

  methods: {
    async verifyLoginAndFetchDetail() {
      await env.init()
      const isLogin = await env.getIsLogin()
      if (!isLogin) {
        return await env.login()
      }
      await this.fetchDetail()
    },

    async fetchDetail() {
      this.loading = true
      try {
        const { data } = await this.$axios.get(
          '/api/activity/fullGift/fullGift/activityDetail',
          {
            params: { activity_id: this.activityId },
            disableLoading: true,
          }
        )
        this.activity = data.activity
        this.userProgress = data.user_progress
        this.progressTipRichText = data.progress_tip_rich_text
        this.tiers = data.tiers
      } catch {
        // errors handled silently; page stays in loading=false state
      } finally {
        this.loading = false
      }
    },

    fmtAmount(amount: string | number): string {
      return formatAmount(amount)
    },

    isSoldOut(tier: Tier): boolean {
      return tier.tier_status === 'out_of_stock' || tier.stock_remaining === 0
    },

    canClaim(tier: Tier): boolean {
      return tier.is_claimable === true
    },

    onClaim(tier: Tier) {
      if (this.loading) return
      this.claimingTierId = tier.id
      if (tier.is_need_receiver) {
        // 需要收货地址：已有地址直接确认，否则先填写
        this.claimDialog =
          this.receiver && this.receiver.id ? 'confirm' : 'fill'
      } else {
        this.doClaim()
      }
    },

    async doClaim() {
      if (this.loading) return
      this.loading = true
      try {
        let requestConfig: any = { disableLoading: true }
        await this.$axios.post(
          '/api/activity/fullGift/fullGift/claimReward',
          {
            activity_id: this.activityId,
            tier_id: this.claimingTierId,
            receiver_id:
              this.receiver && this.receiver.id ? this.receiver.id : undefined,
          },
          requestConfig
        )
        this.claimDialog = 'success'
        await this.fetchDetail()
      } catch {
        // silent
      } finally {
        this.loading = false
      }
    },

    closeClaimDialog() {
      this.claimDialog = ''
      this.claimingTierId = 0
    },

    onMainAction() {
      if (this.activity.status !== 1) return
      // window.location.href = `http://m.ivydad.com.cn/goods/conversion-coin`
      window.location.href = `${window.location.origin}/goods/conversion-coin`
    },

    goMyAward() {
      this.$router.push({
        path: '/fullGift/myReward',
        query: { activity_id: this.activityId },
      })
    },

    goPurchaseRecord() {
      this.$router.push({
        path: '/fullGift/myPurchaseRecord',
        query: { activity_id: this.activityId },
      })
    },
    toAddressList() {
      const receiverId =
        this.receiver && this.receiver.id
          ? this.receiver.id
          : this.$route.query.receiver_id || ''
      // const _head = 'http://m.ivydad.com.cn'
      const _head =
        config.env === 'production'
          ? `https://m.ivydad.com/`
          : `http://m.ivydad.com.cn/`
      // 带上 tier_id，返回时据此恢复确认地址弹窗
      const _redirect = `${window.location.origin}${
        window.location.pathname
      }?id=${this.activityId}&tier_id=${this.claimingTierId}`
      window.location.href =
        `${_head}center/address/addressList?mode=select${
          receiverId ? '&receiverId=' + receiverId : ''
        }&redirect=` + encodeURIComponent(_redirect)
    },

    // 从地址选择页返回：query 带回 receiver_id 与 tier_id，拉取收货人后展示确认地址弹窗
    async checkReturnFromAddress() {
      const { receiver_id, tier_id } = this.$route.query
      if (!receiver_id || !tier_id) return
      await this.loadReceiver(receiver_id as string)
      if (this.receiver) {
        this.claimingTierId = Number(tier_id)
        this.claimDialog = 'confirm'
      }
    },

    async loadReceiver(receiverId: string) {
      try {
        const { data } = await this.$axios.post(
          '/api/mobile/course/yaya/getUserReceiver',
          {},
          { disableLoading: true }
        )
        this.receiver =
          (data || []).find((r: any) => String(r.id) === String(receiverId)) ||
          null
      } catch {
        this.receiver = null
      }
    },
  },
})
